import React, { ComponentType, ReactNode } from 'react'
import { css } from 'src/ui/style/css'

type ContactLinkType = 'tel' | 'email' | 'wa'
export type ContactLinkProps = {
    type: ContactLinkType
    value: string
    children: ReactNode
    className?: string
}

export const ContactLink: ComponentType<ContactLinkProps> = ({
    children,
    type,
    value,
    className
}) => {
    const href =
        type === 'tel'
            ? `tel:${value}`
            : type === 'email'
            ? `mailto:${value}`
            : value
    return (
        <a
            css={css`
                flex-shrink: 0;
            `}
            href={href}
            target={type === 'wa' ? '_blank' : ''}
            className={className}
            rel="noreferrer"
        >
            {children}
        </a>
    )
}
